import { Launch as LaunchIcon } from '@mui/icons-material';
import { Divider, Grid, Typography, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import TwitterPostCard from '../publishedPostsPostCard/twitterPostCard.component'; // Create this
import HttpServices from 'src/services/httpService';
import { postsModuleURL } from 'src/services/urlService';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import { useTranslation } from 'react-i18next';
import twitterIcon from '../../../assets/twitter.svg'; // or X logo

const TwitterPostDetailView = ({ pageId, postId, profile, height }) => {
  const sideBarWidth = 800;
  const { t: translate } = useTranslation();
  const [postDetails, setPostDetails] = useState(null);
  const { showToast } = useToaster();
  const [showLoader, setLoader] = useState(true);

  useEffect(() => {
    getPostDetails();
  }, []);

  const twitterPostDetailsSuccessCallback = (data) => {
    setPostDetails({
      id: data.id,
      media_urls: data.media_urls || [],
      description: data.message,
      like_count: data.like_count,
      reply_count: data.reply_count,
      retweet_count: data.retweet_count,
      bookmark_count: data.bookmark_count,
      impression_count: data.impression_count,
      created_time: data.created_time,
      link: data.link,
    });
    
    setLoader(false);
  };

  const getPostDetails = () => {
    setLoader(true);
    HttpServices.Get({
      url: `${postsModuleURL.getTwitterPostDetails}${pageId}&post_id=${postId}`,
      successCallback: twitterPostDetailsSuccessCallback,
      failureCallback: (msg) => {
        showToast(msg, 'e');
        setLoader(false);
      },
    });
  };

  return (
    <StyledComponent.StyledStack sx={{ width: sideBarWidth }}>
      <Box sx={{ position: 'fixed', width: sideBarWidth, zIndex: 1000, background: 'white' }}>
        <Grid alignItems="center" display="flex" sx={{ pt: 1, pb: 1 }}>
          <img alt="Twitter" width={75} height={40} src={twitterIcon} />
          <Typography color="#000" style={{ fontSize: 25, fontWeight: 800, marginLeft: 8 }}>
           {translate('published_post.twitter')}
          </Typography>
          {postDetails?.link && (
            <a href={postDetails.link} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 'auto' }}>
              <LaunchIcon sx={{ fontSize: '2rem', mr: 2, color: 'primary.main' }} />
            </a>
          )}
        </Grid>
        <Divider />
      </Box>

      <Box sx={{ mt: '5.6rem' }}>
        {showLoader ? (
          <Spinner height={height} />
        ) : (
          <Grid display="flex" alignItems="flex-start" justifyContent="flex-start" sx={{ ml: '1.5rem !important' }}>
            {postDetails && <TwitterPostCard {...postDetails} profile={profile} />}
          </Grid>
        )}
      </Box>
    </StyledComponent.StyledStack>
  );
};

export default TwitterPostDetailView;